import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ApiErrorType } from './ApiErrorType';
import { ErrorContextOf } from './ErrorContext';
export function constructApiError(error, status, responseJson, requestName, context, contextId, details, isClientFetchError, traceId) {
  switch (error) {
    case ApiErrorType.client:
      return {
        error: ApiErrorType.client,
        isClientFetchError: isClientFetchError,
        traceId: traceId,
        status: status,
        requestName: requestName
      };
    case ApiErrorType.clientWithDetails:
      return {
        error: ApiErrorType.clientWithDetails,
        context: ErrorContextOf(context),
        details: details || '',
        isClientFetchError: isClientFetchError,
        traceId: traceId,
        status: status,
        requestName: requestName
      };
    case ApiErrorType.json:
      return {
        error: ApiErrorType.json,
        details: details || '',
        isClientFetchError: isClientFetchError,
        traceId: traceId,
        status: status,
        requestName: requestName
      };
    case ApiErrorType.jwt:
      return {
        error: ApiErrorType.jwt,
        details: details || '',
        isClientFetchError: isClientFetchError,
        traceId: traceId,
        status: status,
        requestName: requestName
      };
    default:
      return {
        error: ApiErrorType.unknown,
        message: error,
        status: status,
        responseJson: responseJson,
        isClientFetchError: isClientFetchError,
        traceId: traceId,
        requestName: requestName
      };
  }
}
export var isUnknownApiError = function isUnknownApiError(apiError) {
  return apiError.error === ApiErrorType.unknown;
};
export var getFormSaveErrors = function getFormSaveErrors(apiError) {
  if (isUnknownApiError(apiError) && apiError.status === 400) {
    return _objectSpread({
      generalErrors: [],
      errorsByQuestionId: {}
    }, apiError.responseJson);
  }
  return undefined;
};
export var getJiraErrorCollectionResponse = function getJiraErrorCollectionResponse(apiError) {
  if (isUnknownApiError(apiError) && apiError.status >= 400 && apiError.status < 500) {
    return _objectSpread({
      errorMessages: [],
      errors: {}
    }, apiError.responseJson);
  }
  return undefined;
};